<template>
    <div>
        <vs-row class="p-4">
            <vs-col w="12" class="text-right mb-4" v-if="general && general.datos">
                <div class="estatus-alumno" :class="coloresEstatus()" v-if="general.datos">
                    <small><strong>{{general.datos.status_id ? status : 'Alumno'}}</strong></small>
                    <!-- <small><strong>{{general.datos.status_id ? estatus[general.datos.status_id]['text'] : 'Alumno'}}</strong></small> -->
                </div>
            </vs-col>
            <vs-col w="12">
                <div class="avatarAlumno">
                    <input type="file" hidden id="imagenSubir" @change="postChangeAvatar($event)">
                    <img :src="img_alumno" alt="alumno" @error="setAltImg">
                    <div class="editarImg" v-if="general && general.datos && !general.datos.usuario_princial">
                        <label for="imagenSubir">
                            <small><i class="fas fa-edit"></i></small>
                        </label>
                    </div>
                </div>
                <div class="text-center infoPrincipal" v-if="general && general.datos">
                    <h5 class=" text-uppercase mt-4"><strong>{{general.datos.apellido_paterno}} {{general.datos.apellido_materno}} {{general.datos.nombres}}</strong></h5>
                </div>
            </vs-col>
            <vs-col w="12">
                <div class="mt-3 infoPrincipal" v-for="(info, i) in info_general" :key="i">
                    <div v-if="info && info.institucion">
                        <p class="mb-0"><strong>{{info.institucion }}</strong></p>
                        <p class="mb-2"><small><i>Institución</i></small></p>
                    </div>
                    <div v-if="info && info.matricula">
                        <p class="mb-0"><strong>{{info.matricula }}</strong></p>
                        <p class="mb-2"><small><i>Matrícula</i></small></p>
                    </div>
                    <div v-if="info && info.ciclo_escolar">
                        <p class="mb-0"><strong>{{info.ciclo_escolar }}</strong></p>
                        <p class="mb-2"><small><i>Ciclo escolar</i></small></p>
                    </div>
                    <div v-if="info && info.programa">
                        <p class="mb-0"><strong>{{info.programa ? info.programa : 'Sin información' }}</strong></p>
                        <p class="mb-2"><small><i>Programa</i></small></p>
                    </div>
                    <div v-if="info && info.grupo_administrativo">
                        <p class="mb-0"><strong>{{info.grupo_administrativo ? info.grupo_administrativo : 'Sin información'}}</strong></p>
                        <p class="mb-2"><small><i>Grupo administrativo (No. Lista)</i></small></p>
                    </div>
                    <div v-if="(info && info.grado) || (info && info.oferta_academica)">
                        <p class="mb-0"><strong>{{info.grado ? info.grado : info.oferta_academica }}</strong></p>
                        <p class="mb-2"><small><i>Oferta académica</i></small></p>
                    </div>
                    <div v-if="info && info.correo">
                        <p class="mb-0"><strong>{{info.correo ? info.correo : 'Sin información' }}</strong></p>
                        <p class="mb-2"><small><i>E-mail</i></small></p>
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'info_general',
        'estatus'
    ],
    data(){
        return{
            img_alumno: '',
            status: ''
        }
    },
    methods:{
        estatusAlumno(){
            const id = this.general.datos.status_id
            const vm = this
            this.estatus.map(e => {
                if(e.id == id){
                    vm.status = e.status
                }
            })
        },
        coloresEstatus(){
            const vm = this
            if([5,16].includes(vm.general.datos.status_id)){
                return 'col-green'
            }else if([6].includes(vm.general.datos.status_id)){
                return 'col-yellow'
            }else if([11, 12, 13, 14, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26].includes(vm.general.datos.status_id)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        async postChangeAvatar(event){
            try{
                const formData = new FormData()
                formData.append('avatar',event.target.files[0])
                const response =  await alumnos.postChangeAvatar(this.general.datos.persona_id, formData)
                this.img_alumno = URL.createObjectURL(event.target.files[0])
            }catch(error){
                console.error(error)
            }
        },
        setAltImg(event) { 
            event.target.src = "/img/default-avatar.jpg" 
        }
    },
    watch:{
        general(){
            this.estatusAlumno()
            this.img_alumno = '/api/personas/' + this.general.datos.persona_id + '/avatar'
        }
    }
}
</script>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }

    .avatarAlumno{
        position: relative;
        border-radius: 50%;
        text-align: center;
        .editarImg{
            position: absolute;
            left: 60%;
            bottom: 5%;
            background-color: #ffff;
            padding: 2px 5px;
            border-radius: 50%;
            border: 1px solid gray;
        }
        img{
            width: 150px;
            height: 150px;
            border-radius: 50%;
            object-fit: cover;
        }
    }

    .infoPrincipal{
        border-bottom:1px solid #dee2e6
    }
    

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
</style>

<style>
html{
    background-color: #eceef7 !important;
}
</style>